<div>
    @if (raceGridRaces && raceGridRaces.data) {
        @if (!raceGridRaces.data.groupedRacing) {
            <div class="loading-v3" data-crlat="flashing.loader"><div class="dot-flashing"></div></div>
        } @else {
            @for (group of raceGridRaces.data.groupedRacing; track trackByGroupedRacing($index, group)) {
                @if (isRaceGridGroup(group)) {
                    <race-grid
                        [eventsData]="raceGridRaces.data"
                        [sportName]="sportName"
                        [eventsOrder]="eventsOrder"
                        [racingGroupFlag]="group.flag"
                        [raceType]="'race'"
                        [racingGroup]="group.data"
                        data-crlat="raceGrid">
                    </race-grid>
                }
            }
        }
    }
</div>
